import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ShieldAlert, ArrowLeft, Home } from 'lucide-react';

const Unauthorized: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-[80vh] flex items-center justify-center p-4">
            <div className="max-w-xs w-full text-center space-y-5">

                {/* Icon */}
                <div className="flex justify-center">
                    <div className="bg-red-50 p-4 rounded-full">
                        <ShieldAlert className="h-10 w-10 text-red-400" strokeWidth={1.5} />
                    </div>
                </div>

                {/* Title & description */}
                <div className="space-y-1.5">
                    <h1 className="text-xl font-semibold text-gray-800">Access Denied</h1>
                    <p className="text-sm text-gray-500 leading-relaxed">
                        You don't have permission to view this page.
                        Contact your administrator to request access.
                    </p>
                </div>

                {/* Info note */}
                <p className="text-xs text-gray-400">Error 403 — Forbidden</p>

                {/* Actions */}
                <div className="flex gap-2">
                    <Button
                        onClick={() => navigate(-1)}
                        variant="outline"
                        size="sm"
                        className="flex-1 gap-1.5 text-xs"
                    >
                        <ArrowLeft className="h-3.5 w-3.5" />
                        Go Back
                    </Button>
                    <Button
                        onClick={() => navigate('/')}
                        size="sm"
                        className="flex-1 gap-1.5 text-xs bg-blue-600 hover:bg-blue-700"
                    >
                        <Home className="h-3.5 w-3.5" />
                        Go Home
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Unauthorized;
